import React, { useState, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { DropdownButton, Dropdown } from 'react-bootstrap';

import { RootState } from 'rootReducer';
import { getAccount, getRoleRequest } from 'modules/auth/containers/Auth/actions';
import ErrorMsg from 'modules/shared/ErrorMsg';
import { useLocation } from 'react-router';
import YesNoModal from 'modules/shared/YesNoModal';
import { useModal, useImageOnLoad } from 'modules/shared/hooks';
import history from 'browserHistory';
import { settingsGlobSelector } from 'modules/admin/containers/SettingsContainer/selectors';
import { forceSaveGlobalSet } from 'modules/admin/containers/SettingsContainer/actions';
import { clearBranchState, forceSaveBranch } from 'modules/admin/containers/BranchEditing/actions';
import { BranchData } from '../../../entities/Branches/interfaces';
import { SecurityGate } from '../../../entities/SecurityGate/interfaces';
import {
  getPheripError,
  getPheripRequest,
  getSecGateError,
  getSecGateRequest,
  setDepTitle as setReduxDepTitle,
} from './actions';
import { routes } from '../../../entities/Roles';
import { Tab as TabProp } from '../../../entities/Tab/interfaces';
import { RoleValues } from '../../../entities/Roles/interfaces';
import Tabs from './components/Tabs';
import Tab from './components/Tab';
import { cleanTrip, forceSaved } from '../CommonTrip/actions';
import { tripSavedSelector } from '../CommonTrip/selectors';
import { deleteTab } from '../Tabs/actions';
import { securityGateSelector, depTitleSelector, securityGateGlobalSelector } from './selectors';

import LogoutBtn from '../LogoutBtn';
// import { setReduxBranchTitle } from '../LogoutBtn/actions';
import { logoutSelector } from '../LogoutBtn/selectors';
import BtnTab from './components/BtnTab';
import logo from './assets/logo.png';
import styles from './Header.module.scss';
import OrderMsg from '../../shared/OrderMsg';
import { bookingModalSelector } from '../BookingModal/selector';
import HeaderSpiner from '../HeaderSpiner/HeaderSpiner';
import { reservationsSelector } from '../../manager/containers/Booking/services/selectors';
import {
  getAllBooksError,
  getCellSettingsError,
  getLockedCellError,
} from '../../manager/containers/Booking/services/actions';
import { getUserBranchesRequest } from '../LogoutBtn/actions';

type Props = {
  defaultActiveKey?: string;
};

const Header: React.FC<Props> = ({ defaultActiveKey }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [hrefs, setHrefs] = useState('');
  const { isShow, openModal, closeModal } = useModal();
  const { isShow: isShowPopup, openModal: openPopup, closeModal: closePopup } = useModal();
  const { saved } = useSelector(tripSavedSelector);
  const depTitle = useSelector(depTitleSelector);
  const { aadGroups } = useSelector(logoutSelector);

  const [activeRoleSegment] = useMemo(() => location.pathname.slice(1).split('/'), [location]);
  const activeRole = useMemo(
    () => (Object.keys(routes) as RoleValues[]).find((key) => routes[key] === `/${activeRoleSegment}`),
    [activeRoleSegment],
  );

  const branchFromStorage = JSON.parse(localStorage.getItem('branchId') || 'null');

  const [depError, setDepError] = useState<string | null>(null);

  const auth = useSelector((state: RootState) => state.authModuleReducer.authReducer);
  const headerLoader = useSelector((state: RootState) => state.managerModuleReducer.reservationsReducer.headerLoader);
  const { books, lockedCell } = useSelector(reservationsSelector);
  const cellSetting = useSelector((state: RootState) => state.managerModuleReducer.reservationsReducer.cellSetting);
  const securityGate = useSelector(securityGateSelector);
  const { secGateError, peripheralsError } = useSelector(securityGateGlobalSelector);
  const { tabs = [] } = useSelector((state: RootState) => state.commonReducer.tabsReducer);
  const { branchTitle, branches } = useSelector(logoutSelector);
  const { savedSet } = useSelector(settingsGlobSelector);

  const { cellSettingsError, lockedCellError, managerBooksError }: any = useSelector(
    (state: RootState) => state.managerModuleReducer.reservationsReducer,
  );

  const [isLoading, setIsLoading] = useState(true);

  // @ts-ignore
  const errorMsg = useSelector((state: RootState) => state.commonReducer.tripFieldsReducer.error);
  // @ts-ignore
  const showPopUp = useSelector((state: RootState) => state.commonReducer.tripFieldsReducer.showPopUp);
  // @ts-ignore
  const showErrorReqDoc = useSelector((state: RootState) => state.commonReducer.tripFieldsReducer.showErrorReqDoc);
  const showErrorReqDocText = useSelector(
    // @ts-ignore
    (state: RootState) => state.commonReducer.tripFieldsReducer.showErrorReqDocText,
  );
  const { wrongIddp } = useSelector(bookingModalSelector);
  const { handleImageOnLoad, css } = useImageOnLoad();

  const isSuperUser = auth.role?.name && auth.role?.name === RoleValues.ARM_SUPERUSER;
  const path = history.location.pathname.split('/')[1];
  const isGlobalSet = location.pathname.includes(`/${path}/settings`);
  const isTrip = location.pathname.includes(`/${path}/trip`);
  const isBranch = location.pathname.includes(`/${path}/branch`);
  const isAdmin = location.pathname.includes(`globaladmin`);
  const isManager = activeRole === RoleValues.ARM_MANAGER;
  const isDirector = activeRole === RoleValues.ARM_DIRECTOR;

  const department = useMemo(() => {
    if (!activeRole) return null;

    if (activeRole === RoleValues.ARM_OHRANA && securityGate) {
      return {
        name: 'КПП',
        items: securityGate,
      };
    }

    if ([RoleValues.ARM_MANAGER, RoleValues.ARM_SUPERUSER].includes(activeRole)) {
      return {
        name: 'Підрозділ',
        items: branches,
      };
    }
  }, [branches, securityGate, activeRole]);

  const departmentSelection = useMemo(() => {
    if (!activeRole) return null;

    return {
      name: 'Підрозділ',
      items: aadGroups ?? [],
    };
  }, [activeRole, aadGroups]);

  const onDropdown = (eventKey: any, a: any, isSecurityGate: boolean) => {
    const { id } = a.target;

    setDepError(null);

    if (isManager || (!isSecurityGate && departmentSelection && departmentSelection.items)) {
      if (!aadGroups) return;
      const branch = aadGroups.find((b) => +b.id === +id);
      localStorage.setItem('branchId', JSON.stringify(branch));
      dispatch(getRoleRequest());
      window.location.reload();
      return;
    }

    localStorage.setItem('depTitle', JSON.stringify({ id, name: eventKey }));
    dispatch(setReduxDepTitle({ name: eventKey, id }));
    dispatch(getPheripRequest(id));
  };

  const closeTripHandler = () => {
    const tripId = history.location.pathname.split('/')[3];
    setHrefs('');

    if (isTrip) {
      dispatch(deleteTab(`trip_${tripId}`));
      dispatch(cleanTrip());
    }

    if (isBranch) {
      dispatch(deleteTab(`branch_${tripId}`));
      dispatch(clearBranchState());
    }

    closeModal();
    if (hrefs) return history.push(hrefs);
    history.push(`/${path}`);
  };

  const saveHandler = () => {
    closeModal();

    if (isTrip) dispatch(forceSaved(hrefs));
    if (isGlobalSet) dispatch(forceSaveGlobalSet(true));

    if (isBranch) dispatch(forceSaveBranch(true));

    setTimeout(() => closeTripHandler(), 300);
  };

  const saveChanges = (href: string) => {
    setHrefs(href);

    if (isTrip && location.pathname !== href && !saved) return openModal();
    if (isGlobalSet && location.pathname !== href && !savedSet) return openModal();
    if (isBranch && location.pathname !== href && !saved) return openModal();

    closeTripHandler();
  };

  useEffect(() => {
    if (!depTitle) {
      const localDep = localStorage.getItem('depTitle') || 'null';
      if (localDep) dispatch(setReduxDepTitle(JSON.parse(localDep)));
    }
  }, []);

  useEffect(() => {
    dispatch(getAccount());
    dispatch(getRoleRequest());

    if (auth.role) {
      if (isSuperUser && !branchTitle) return;

      const params = {};

      if (isSuperUser) {
        // @ts-ignore
        params.branchId = JSON.parse(localStorage.getItem('branchId'))?.id;
      }

      dispatch(getSecGateRequest(params));
    }

    if (activeRoleSegment === 'ordering') dispatch(getPheripRequest('0'));

    if (depTitle && branchTitle && activeRoleSegment !== 'ordering' && activeRoleSegment !== 'globaladmin') {
      dispatch(getPheripRequest(depTitle.id));
    }

    const branchErrorTimioutId = setTimeout(() => {
      if (isManager && !depTitle) {
        setDepError('Підрозділ не обрано');
      }
    }, 3000);

    return () => {
      if (branchErrorTimioutId) {
        clearTimeout(branchErrorTimioutId);
      }
    };
  }, [branchTitle, depTitle]);

  useEffect(() => {
    if (!depTitle && department && department.items && department.items.length > 0) {
      const defaultDep =
        department.items.find(
          ({ id }: { id: number }) => id === JSON.parse(localStorage.getItem('branchId') || 'null').id ?? 0,
        ) ?? department.items[0];
      const defaultDepId = defaultDep.id.toString();
      const defaultDepName = defaultDep.name;

      setIsLoading(false);

      dispatch(setReduxDepTitle({ name: defaultDepName, id: defaultDepId }));
      dispatch(getPheripRequest(defaultDepId));
    }

    if (department?.items?.length === 0 && !isLoading && !isSuperUser) {
      setDepError('КПП немає');
    }
  }, [department]);

  useEffect(() => {
    if (secGateError || peripheralsError || cellSettingsError || lockedCellError || managerBooksError) {
      openPopup();
    }
  }, [secGateError, peripheralsError, cellSettingsError, lockedCellError, managerBooksError]);

  useEffect(() => {
    dispatch(getUserBranchesRequest());
  }, []);
  return (
    <header className="container-fluid">
      <ErrorMsg isShow={!!depError} error={depError || ''} closeHandler={() => setDepError(null)} />
      <OrderMsg
        isShow={showPopUp}
        error={
          errorMsg?.data?.ManualAllowed !== undefined
            ? `${errorMsg?.data?.Errors[0]?.Message}. Введіть значення ваги вручну.`
            : errorMsg?.data?.Errors[0]?.Message
        }
      />
      <OrderMsg
        isShow={wrongIddp}
        error="Введений номер замовлення належить іншій компанії, додавання в дане бронювання неможливе."
      />
      <OrderMsg
        isShow={showErrorReqDoc}
        error={showErrorReqDocText !== '' ? showErrorReqDocText?.data?.Errors[0]?.Message : 'Сталася внутрішня помилка'}
      />
      <div className={classNames('d-flex justify-content-between align-items-center p-2', styles.top)}>
        <div className={classNames('d-flex flex-column text-white ml-3', styles.info)}>
          <span className="font-weight-bolder">
            Електронна черга v{process.env.REACT_APP_VERSION}/{process.env.REACT_APP_VERSION_DATA}
          </span>
          <span>
            {auth.account?.username}{' '}
            {!isManager ? (
              <span>
                {auth.role?.title &&
                  `(${process.env.REACT_APP_STAGE}, ${auth.role?.title}, ${
                    auth.role?.branches[0]?.name?.length
                      ? `${auth.role?.branches[0]?.name}, код: ${auth.role?.branches[0]?.id}`
                      : ''
                  })`}
              </span>
            ) : (
              <span>
                {auth.role?.title &&
                  `(${process.env.REACT_APP_STAGE}, ${auth.role?.title}, ${
                    departmentSelection?.items.find(
                      ({ id }: { id: number }) =>
                        id === JSON.parse(localStorage.getItem('branchId') || 'null')?.id ?? 0,
                    )?.name ?? ''
                  }, код: ${
                    departmentSelection?.items.find(
                      ({ id }: { id: number }) =>
                        id === JSON.parse(localStorage.getItem('branchId') || 'null')?.id ?? 0,
                    )?.id ?? ''
                  })`}
              </span>
            )}
            {/* {auth.role?.title && */}
            {/*  `(${process.env.REACT_APP_STAGE}, ${auth.role?.title}, ${ */}
            {/*    branchTitle?.name?.length ? `${branchTitle.name}, код: ${branchTitle.id}` : '' */}
            {/*  })`} */}
          </span>
        </div>
        <div className="d-flex align-items-center">
          {(isManager || isDirector) &&
          (headerLoader || books === null || lockedCell === null || Object.keys(cellSetting).length === 0) ? (
            <HeaderSpiner />
          ) : null}
          <img
            src={logo}
            className={styles.logo}
            alt="Логотип Метінвест"
            onLoad={handleImageOnLoad}
            style={{ ...css.fullSize }}
          />
          <LogoutBtn classNameLogout={styles.logout} classNameItem={styles.item} />
        </div>
      </div>
      <div className={classNames('d-flex justify-content-between', styles.bottom)}>
        <Tabs defaultActiveKey={defaultActiveKey} className={classNames('ml-0 nav-item nav-tabs', styles.row)}>
          {tabs.map((tab: TabProp) => {
            if ((isTrip || isBranch || isGlobalSet) && location.pathname !== tab.href) {
              return <BtnTab key={tab.id} {...tab} saveChanges={() => saveChanges(tab.href)} />;
            }
            return <Tab key={tab.id} {...tab} />;
          })}
        </Tabs>
        <div className="d-flex flex-row">
          {!!department && department.items && !isManager && (
            <div className="d-flex align-items-center mr-2">
              <span className="mr-2">{department.name}:</span>
              <DropdownButton
                menuAlign="right"
                variant="outline-secondary"
                className={classNames('p-0', styles.department)}
                title={depTitle?.name || 'Оберіть КПП'}
                onSelect={(e: any, a: any) => onDropdown(e, a, true)}
                disabled={!branchTitle && !branchFromStorage}
              >
                {department.items.map((dep: BranchData | SecurityGate) => (
                  <Dropdown.Item key={dep.id} className={styles.item} eventKey={dep.name} id={dep.id}>
                    {dep.name}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </div>
          )}

          {!isAdmin && !!departmentSelection && departmentSelection.items && (
            <div className="d-flex align-items-center mr-2">
              <span className="mr-2">Оберіть підрозділ:</span>
              <DropdownButton
                menuAlign="right"
                variant="outline-secondary"
                className={classNames('p-0', styles.department)}
                title={
                  departmentSelection.items.find(
                    ({ id }: { id: number }) => id === JSON.parse(localStorage.getItem('branchId') || 'null')?.id ?? 0,
                  )?.name || 'Оберіть підрозділ'
                }
                onSelect={(e: any, a: any) => onDropdown(e, a, false)}
                disabled={isTrip || (!branchTitle && !branchFromStorage)}
              >
                {departmentSelection.items
                  .filter((item: any) => item.id !== 0 && !item.isDeleted)
                  .map((dep: BranchData | SecurityGate) => (
                    <Dropdown.Item key={dep.id} className={styles.item} eventKey={dep.name} id={dep.id}>
                      {dep.name}
                    </Dropdown.Item>
                  ))}
              </DropdownButton>
            </div>
          )}
        </div>
      </div>
      <YesNoModal
        isShow={isShow}
        title="Вкладку буде закрито. Зберегти зміни"
        acceptHandler={saveHandler}
        closeHandler={closeModal}
        closeModal={closeTripHandler}
      />
      <ErrorMsg
        isShow={isShowPopup}
        closeHandler={() => {
          closePopup();
          if (secGateError) {
            dispatch(getSecGateError(null));
          }
          if (peripheralsError) {
            dispatch(getPheripError(null));
          }
          if (cellSettingsError) {
            dispatch(getCellSettingsError(null));
          }
          if (lockedCellError) {
            dispatch(getLockedCellError(null));
          }
          if (managerBooksError) {
            dispatch(getAllBooksError(null));
          }
        }}
        // @ts-ignore
        error={
          secGateError?.message ||
          peripheralsError?.message ||
          cellSettingsError?.message ||
          lockedCellError?.message ||
          managerBooksError?.message ||
          'Виникла помилка'
        }
      />
    </header>
  );
};

export default Header;
